import axios from 'axios'
import config from '../config'

export default {
    getSpamMxList(currentPage, perPage, search) {
        return axios.get(config.publicPath + 'dns_records', {
            params: {_page: currentPage, itemsPerPage: perPage, value: search, type:'MX', isBlacklisted: 1},
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },
    addSpamMx(mx) {
        return axios.post(config.publicPath + 'add-spam-mx', {mx: mx}, {
            headers: {
                'Content-Type': 'application/json'
            },
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            }
        });
    },
    addSpamMxs(formData) {
        return axios.post(config.publicPath + 'add-spam-mxs', formData, {
            headers: {
                'Content-Type': 'application/json',
            },
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            },
        });
    },
    deleteSpamMx(id) {
        return axios.post(config.publicPath + 'remove-spam-mx', {recordId: id}, {
            headers: {
                'Content-Type': 'application/json'
            },
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            }
        });
    }
}
